import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitobarodacab() {



  const cardData = {
    keyword: " Mumbai to Baroda Cabs ",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Vadodara (Baroda) cab services, ensuring a smooth, safe, and hassle-free long-distance journey for families, business travelers, and group passengers. Vadodara is a major cultural and industrial city of Gujarat, known for its heritage palaces, educational institutions, and growing business hubs, making it a frequently traveled route from Mumbai. Our professional drivers and well-maintained vehicles ensure a stress-free travel experience throughout the journey. The Mumbai to Vadodara route covers approximately 400 to 430 km via NH48 and takes around 7 to 9 hours depending on traffic and road conditions. Typical cab fares range from ₹5,500 to ₹9,500 for hatchbacks and sedans, while SUVs can go higher depending on vehicle type, tolls, and travel timing. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Vadodara travel.",

"topPlaces": [
  {
    "title": "Laxmi Vilas Palace",
    "description": "Laxmi Vilas Palace is one of the grandest royal residences in India, built by the Gaekwad dynasty. It is four times larger than Buckingham Palace and showcases Indo-Saracenic architecture, lavish interiors, and vast courtyards. Visitors can explore its museum section, art collections, and beautifully maintained gardens, making it a must-visit landmark in Vadodara."
  },
  {
    "title": "Sayaji Baug (Kamati Baug)",
    "description": "Sayaji Baug is a large public garden and one of the most popular recreational spaces in Vadodara. It houses a zoo, planetarium, museum, and toy train, making it ideal for family outings. The lush greenery, walking paths, and peaceful environment provide a refreshing break within the city."
  },
  {
    "title": "EME Temple",
    "description": "The EME Temple is a unique modern temple dedicated to Lord Dakshinamurthy and maintained by the Indian Army. Known for its futuristic aluminum dome structure, it symbolizes harmony between religions and architectural innovation. The peaceful surroundings and disciplined maintenance attract both devotees and tourists."
  },
  {
    "title": "Sursagar Lake",
    "description": "Sursagar Lake is a scenic water body located in the heart of Vadodara city. The lake is famous for its massive statue of Lord Shiva standing in the center and its beautifully lit surroundings in the evening. It is a popular spot for evening walks, photography, and relaxation."
  },
  {
    "title": "Baroda Museum & Picture Gallery",
    "description": "The Baroda Museum & Picture Gallery is a historic museum showcasing artifacts, sculptures, Egyptian antiquities, and European paintings. It reflects the cultural richness and artistic heritage of the region and is one of the oldest museums in Gujarat."
  },
  {
    "title": "Kirti Mandir",
    "description": "Kirti Mandir is a cenotaph built in memory of the Gaekwad royal family. It features beautiful murals, carvings, and architectural details that reflect the history of Vadodara’s royal lineage. It is an important heritage site for history lovers."
  },
  {
    "title": "Narmada Canal Viewpoint (Vadodara outskirts)",
    "description": "The Narmada Canal area near Vadodara offers peaceful scenic views, especially during sunrise and sunset. It is a calm spot for travelers looking to relax near water bodies and enjoy nature away from the city’s hustle."
  },
  {
    "title": "Ajwa Nimeta Garden",
    "description": "Ajwa Nimeta Garden is a beautifully designed musical fountain garden located on the outskirts of Vadodara. It features landscaped gardens, synchronized fountain shows, and a peaceful environment ideal for evening visits and family outings."
  },
  {
    "title": "Makarpura Palace",
    "description": "Makarpura Palace is a historic royal palace that now serves as an Air Force training center. Though entry is restricted, its exterior architecture and historical significance attract visitors interested in Vadodara’s royal past."
  },
  {
    "title": "ISKCON Temple Vadodara",
    "description": "ISKCON Temple Vadodara is a peaceful spiritual center dedicated to Lord Krishna. It offers devotional chanting, cultural programs, and a serene environment for meditation and spiritual learning."
  }
],






services: [
  {
    name: "Mumbai to Baroda Cab",
    description: "Mumbai to Baroda cab service offers a smooth and comfortable journey to Vadodara, one of Gujarat’s major cities. The route via NH48 ensures fast highway connectivity with scenic stretches along the way. Ideal for business travelers, families, and tourists, this service provides safe and timely travel. Professional drivers and well-maintained vehicles enhance comfort. Multiple car options are available. It guarantees a reliable and hassle-free journey."
  },
  {
    name: "Mumbai to Baroda Taxi",
    description: "Mumbai to Baroda taxi provides convenient and private transportation with door-to-door pickup and drop. This service is ideal for travelers seeking a comfortable ride for long-distance journeys. Vehicles are clean and driven by experienced chauffeurs. Suitable for both personal and corporate travel. It ensures a smooth and stress-free experience."
  },
  {
    name: "Mumbai Airport to Vadodara Taxi Fare",
    description: "Mumbai airport to Vadodara taxi fare is structured to offer transparent and competitive pricing for travelers. Pricing depends on vehicle type, distance, and trip duration. Customers receive a clear fare breakdown with no hidden charges. Budget and premium options are available. It helps travelers plan their journey efficiently."
  },
  {
    name: "Mumbai Airport to Vadodara Taxi",
    description: "Mumbai airport to Vadodara taxi service provides direct and comfortable transfer for passengers arriving at the airport. This service ensures timely pickup and smooth highway travel. Professional drivers and clean vehicles enhance the journey. It is perfect for business travelers and tourists. It guarantees a seamless travel experience."
  },
  {
    name: "One Way Cab Mumbai to Vadodara",
    description: "One way cab Mumbai to Vadodara is a cost-effective option for travelers needing a single-side journey. This service eliminates return charges and offers flexible travel timings. Ideal for business trips and relocations. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Vadodara One Way Cab",
    description: "Mumbai to Vadodara one way cab provides affordable and convenient travel without return cost. This service is ideal for those planning extended stays in Vadodara. Flexible pickup options and experienced drivers ensure safe travel. It offers a comfortable and economical journey."
  },
  {
    name: "One Way Cab from Mumbai to Vadodara",
    description: "One way cab from Mumbai to Vadodara offers a flexible and budget-friendly travel solution for long-distance journeys. Customers can choose vehicle types based on comfort and group size. Professional drivers ensure timely travel. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Vadodara Cab",
    description: "Mumbai to Vadodara cab service provides reliable intercity transportation with a focus on safety and comfort. This service is suitable for business trips, family travel, and tourism. Vehicles are well-maintained for long routes. It ensures a smooth and enjoyable journey."
  },
  {
    name: "Mumbai to Vadodara Taxi",
    description: "Mumbai to Vadodara taxi offers convenient and efficient travel between the two cities. With experienced drivers and comfortable vehicles, this service ensures smooth highway travel. Door-to-door pickup and drop add convenience. It guarantees a reliable journey."
  },
  {
    name: "Mumbai to Vadodara Taxi Fare",
    description: "Mumbai to Vadodara taxi fare is designed to be affordable and transparent for all travelers. Fare depends on car type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "One Way Cab from Mumbai Airport to Vadodara",
    description: "One way cab from Mumbai airport to Vadodara offers direct and comfortable travel for arriving passengers. This service is ideal for long-distance airport transfers. Professional drivers ensure timely pickup and safe travel. It provides a convenient and hassle-free journey."
  },
  {
    name: "Mumbai Airport to Vadodara Cab",
    description: "Mumbai airport to Vadodara cab service ensures smooth and reliable travel from airport to destination. Vehicles are clean and maintained for long-distance travel. Experienced drivers provide safe journeys. It is ideal for business and leisure travelers."
  },
  {
    name: "Mumbai to Baroda Taxi Fare",
    description: "Mumbai to Baroda taxi fare offers competitive pricing for long-distance journeys. Transparent fare structure ensures no hidden charges. Customers can choose from budget-friendly and premium options. It helps in easy travel planning. It ensures value for money."
  },
  {
    name: "One Way Taxi from Mumbai to Vadodara",
    description: "One way taxi from Mumbai to Vadodara is a convenient option for travelers who require a single-side trip. This service is affordable and flexible. Professional drivers and comfortable vehicles ensure smooth travel. It is ideal for business and personal trips."
  },
  {
    name: "Cab from Vadodara to Mumbai",
    description: "Cab from Vadodara to Mumbai provides reliable return travel with comfortable vehicles and experienced drivers. This service is suitable for business trips, family visits, and airport transfers. Flexible pickup options enhance convenience. It ensures a safe and smooth journey."
  },
  {
    name: "Mumbai to Baroda Cab Price",
    description: "Mumbai to Baroda cab price varies based on vehicle type, travel timing, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan efficiently. It ensures value-driven travel."
  },
  {
    name: "Mumbai to Baroda One Way Cab",
    description: "Mumbai to Baroda one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible scheduling. Ideal for long-distance travel. Comfortable vehicles ensure a smooth ride."
  },
  {
    name: "One Way Cab Vadodara to Mumbai Airport",
    description: "One way cab Vadodara to Mumbai airport provides direct and reliable airport transfer service. This service ensures timely arrival for flights with professional drivers. Comfortable vehicles and flexible pickup enhance convenience. It ensures a stress-free journey."
  },
  {
    name: "Mumbai to Vadodara Cab Service",
    description: "Mumbai to Vadodara cab service ensures premium travel experience with well-maintained vehicles and professional drivers. This service focuses on safety, punctuality, and customer satisfaction. Multiple vehicle options are available. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Baroda Cab", "Mumbai to Baroda Taxi"],
  ["Mumbai Airport to Vadodara Taxi Fare", "Mumbai Airport to Vadodara Taxi"],
  ["One Way Cab Mumbai to Vadodara", "Mumbai to Vadodara One Way Cab"],
  ["One Way Cab from Mumbai to Vadodara", "Mumbai to Vadodara Cab"],
  ["Mumbai to Vadodara Taxi", "Mumbai to Vadodara Taxi Fare"],
  ["One Way Cab from Mumbai Airport to Vadodara", "Mumbai Airport to Vadodara Cab"],
  ["Mumbai to Baroda Taxi Fare", "One Way Taxi from Mumbai to Vadodara"],
  ["Cab from Vadodara to Mumbai", "Mumbai to Baroda Cab Price"],
  ["Mumbai to Baroda One Way Cab", "One Way Cab Vadodara to Mumbai Airport"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Baroda Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Baroda cab service, ideal for business trips, family travel, and long-distance journeys."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mumbai to Baroda routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Baroda cab service operates 24/7, allowing flexible travel anytime as per your schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel options for Baroda trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Baroda cab bookings due to punctual service, professional drivers, and reliable experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Baroda cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Baroda for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Baroda?", answer: "The distance is approximately 400 to 420 km and takes around 7 to 9 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Baroda cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during peak travel seasons." },
  { question: "Do you provide night travel service?", answer: "Yes, we provide safe night travel with experienced drivers." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Patel",
    feedback: "Travel from Mumbai to Baroda with Royal Route Cabs was smooth and comfortable. The driver was punctual and ensured a safe long-distance journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Divya Shah",
    feedback: "Royal Route Cabs made the Mumbai to Baroda trip very easy and stress-free. The cab was clean and the overall experience was professional and reliable.",
    rating: 5
  }
];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Baroda (Vadodara) Cabs",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-vadodara-cab.jpg", // replace if needed
  "description": "Book Mumbai to Baroda (Vadodara) cab with Royal Route Cabs for a safe, comfortable, and affordable long-distance journey. Available one-way and round-trip taxi services from Mumbai Airport and city with sedan, SUV, Innova, and luxury cars. 24x7 reliable drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5500", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-baroda-cab"
  }
};



  return (
    <div>

<Helmet>
  <title>Mumbai to Baroda (Vadodara) Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Baroda (Vadodara) cab at best price with Royal Route Cabs. One-way & round-trip taxi service from Mumbai Airport & city with sedan, SUV, Innova & luxury cars. Safe & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to baroda cab, mumbai to vadodara taxi, mumbai airport to vadodara taxi fare, mumbai airport to vadodara taxi, one way cab mumbai to vadodara, mumbai to vadodara one way cab, one way cab from mumbai to vadodara, mumbai to vadodara cab, mumbai to vadodara taxi fare, one way cab from mumbai airport to vadodara, mumbai airport to vadodara cab, mumbai to baroda taxi fare, one way taxi from mumbai to vadodara, cab from vadodara to mumbai, mumbai to baroda cab price, mumbai to baroda one way cab, one way cab vadodara to mumbai airport, mumbai to vadodara cab service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitobarodacab;